import { useEffect } from "react";
import { Href } from "../utils/helper";

const RedirectEntry = ({ blok }) => {
  useEffect(() => {
    window.location.href = Href(blok.target_story)
  })
  return null
};

export default RedirectEntry
